import {
    VerificationTransactionsSearchResults,
    VerificationTransactionsSearchFiltersState
} from "@idw-types/state/verification-transactions-state";

export enum VerificationTransactionsActionTypes {
    // Search
    SET_VERIFICATION_TRANSACTIONS_SEARCH_FILTERS = "SET_VERIFICATION_TRANSACTIONS_SEARCH_FILTERS",
    SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS_LOADING = "SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS_LOADING",
    SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS = "SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS"
}

// Search
type SetVerificationTransactionsSearchFiltersAction = {
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_FILTERS;
    payload: { searchFilters: VerificationTransactionsSearchFiltersState };
};

export const setVerificationTransactionsSearchFilters = (
    searchFilters: VerificationTransactionsSearchFiltersState
): SetVerificationTransactionsSearchFiltersAction => ({
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetVerificationTransactionsSearchResultsLoadingAction = {
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setVerificationTransactionsSearchResultsLoading = (
    isLoading: boolean
): SetVerificationTransactionsSearchResultsLoadingAction => ({
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetVerificationTransactionsSearchResultsAction = {
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS;
    payload: { verificationTransactionsSearchResults: VerificationTransactionsSearchResults };
};

export const setVerificationTransactionsSearchResults = (
    verificationTransactionsSearchResults: VerificationTransactionsSearchResults
): SetVerificationTransactionsSearchResultsAction => ({
    type: VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS,
    payload: { verificationTransactionsSearchResults }
});

export type VerificationTransactionsActions =
    // Search
    SetVerificationTransactionsSearchFiltersAction |
    SetVerificationTransactionsSearchResultsLoadingAction |
    SetVerificationTransactionsSearchResultsAction